import React from 'react';
import { debounce } from 'lodash';

const usePasswordCheck = (password: string) => {
	const [passwordRequirements, setPasswordRequirements] = React.useState<PasswordRequirements>({
		includeUpperAndLowerCase: false,
		includeAtLeastOneNumber: false,
		hasEightOrMoreCharacters: false,
	});

	const checkPassword = React.useCallback(
		debounce((password) => {
			let includeUpperAndLowerCase = false;
			let includeAtLeastOneNumber = false;
			let hasEightOrMoreCharacters = false;

			if (/[a-z]/.test(password) && /[A-Z]/.test(password)) {
				includeUpperAndLowerCase = true;
			}
			if (/[0-9]/.test(password)) {
				includeAtLeastOneNumber = true;
			}
			if (password.length >= 8) {
				hasEightOrMoreCharacters = true;
			}
			setPasswordRequirements({
				includeUpperAndLowerCase,
				includeAtLeastOneNumber,
				hasEightOrMoreCharacters,
			});
		}, 300),
		[]
	);

	React.useEffect(() => {
		checkPassword(password);
	}, [checkPassword, password]);

	return passwordRequirements;
};

export default usePasswordCheck;

type PasswordRequirements = {
	includeUpperAndLowerCase: boolean;
	includeAtLeastOneNumber: boolean;
	hasEightOrMoreCharacters: boolean;
};
